export default __webpack_public_path__ + "static/media/dgt_collated.0427aef7.jpg";